import { connect } from 'react-redux';

import AdminPageComponent from '../components/admin/AdminPageComponent';
import { getCurrentUser } from './selectors/userSelectors';
import { getPendingFacilitiesAdmin, updatePendingFacilities } from '../store/actions/licenses';

const mapStateToProps = (state) => {
    return {
        user: getCurrentUser(state),
    };
};

const mapDispatchToProps = {
    getPendingFacilitiesAdmin,
    updatePendingFacilities,
};

const mergeProps = (
    { user },
    { getPendingFacilitiesAdmin, updatePendingFacilities }
) => ({
    user,
    getPendingFacilitiesAdmin,
    updatePendingFacilities,
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(AdminPageComponent);



// WEBPACK FOOTER //
// ./src/containers/AdminPageContainer.js